var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBbListRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914",
    transform: "translate(-3741 -6799)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(3741 6799)",
    fill: "#c8372f",
    opacity: 0.999
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    transform: "translate(3082.5 5856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_20",
    "data-name": "Line 20",
    d: "M16,1H0V-1H16Z",
    transform: "translate(665.5 953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_21",
    "data-name": "Line 21",
    d: "M16,1H0V-1H16Z",
    transform: "translate(665.5 958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_22",
    "data-name": "Line 22",
    d: "M10,1H0V-1H10Z",
    transform: "translate(665.5 963)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbListRed);
export default __webpack_public_path__ + "static/media/bb-list_red.d20fe47cb25bdad32cd36bf361667c46.svg";
export { ForwardRef as ReactComponent };